
import { Component, Vue, Watch } from 'vue-property-decorator';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import { MoovCard, PaymentProviderCardDetails } from '@/interfaces/payment-options';
import Alert from '~/components/Alerts/Alert.vue';
import BankAccountSetup from '@/views/BankAccountSetup/BankAccountSetup.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import PageLoader from '@/components/common/PageLoader.vue';
import PaymentSettingsCard from '@/components/common/Cards/PaymentSettingsCard.vue';
import { PaymentProviderBankDetails, VerificationStatuses } from '@/interfaces/bank-account';
import ManagePaymentMethod from '@/components/BankAccountSetup/ManagePaymentMethod.vue';
import CardInput from '@/components/Payments/CardInput.vue';

@Component({
  components: {
    CardInput,
    Alert,
    BankAccountSetup,
    CustomButton,
    PageLoader,
    PaymentSettingsCard,
    ManagePaymentMethod,
  }
})
export default class PaymentSettingsView extends Vue {
  loading = false;

  expandedBankCard = false;

  expandedCardCard = false;

  get bankAccount(): PaymentProviderBankDetails | null {
    return this.$store.getters['PaymentOptions/getBankAccount'];
  }

  get bankAccountVerified(): boolean {
    return this.$store.getters['PaymentOptions/bankAccountIsVerified'];
  }

  get card(): PaymentProviderCardDetails | null {
    return this.$store.getters['PaymentOptions/getCard'];
  }

  async getPaymentOptions() {
    try {
      await this.$store.dispatch('PaymentOptions/getPaymentOptions');
    } catch {
      this.$router.push({ name: 'error' });
    }
  }

  async onCardAddSuccess(card: MoovCard) {
    this.$alerts.add({
      timed: true,
      type: GlobalAlertTypes.SUCCESS,
      text: `You are ready to transact with the debit card ending in ${card.lastFourCardNumber}`
    });
    await this.getPaymentOptions();
  }

  async refreshOptions() {
    this.loading = true;
    await this.getPaymentOptions();
    this.loading = false;
  }

  async onBankSuccess(lastFour: string) {
    await this.refreshOptions();
    this.$alerts.add({
      timed: true,
      type: GlobalAlertTypes.SUCCESS,
      text: `You are ready to transact with the bank account ending in ${lastFour}`
    });
  }

  @Watch('bankAccount', { immediate: true })
  onBankAccountsUpdate(bankAccount: PaymentProviderBankDetails) {
    if (
      bankAccount
      && [VerificationStatuses.VERIFIED, VerificationStatuses.CRB_ONBOARDED]
        .includes(bankAccount?.bank_status)
    ) {
      this.expandedBankCard = true;
    }
  }
}
